import { ConvexReactClient } from "convex/react";
// import { getConvexUrlOptional } from "@dnplace/config/browser"; // Temporarily disabled for debugging

interface ImportMetaEnv {
  VITE_CONVEX_URL?: string;
}

const convexUrl = (import.meta.env as ImportMetaEnv)?.VITE_CONVEX_URL || "http://127.0.0.1:3210";
console.log("🔍 Debug: Convex URL:", convexUrl);
export const convex = new ConvexReactClient(convexUrl);

/**
 * Update the global Convex client auth token
 * 
 * ✅ FIX: Called from AuthContext after JWT refresh to ensure org_id is included
 * Note: Convex now requires an async function, not a direct token string
 */
export function updateConvexAuth(fetchToken: () => Promise<string | null>): void {
  console.log('🔄 Updating global Convex client auth with token fetcher');
  convex.setAuth(async () => (await fetchToken()) ?? null);
}

// ------------------------------------------------------------
// Debug: Inspect fetch headers for Convex requests (one-time)
// ------------------------------------------------------------
try {
  const w = window as Window & { __dnplace_convex_fetch_debug?: boolean };
  if (!w.__dnplace_convex_fetch_debug && typeof window !== 'undefined') {
    w.__dnplace_convex_fetch_debug = true;
    const originalFetch = window.fetch.bind(window);
    window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
      // CRITICAL: Access headers in a try/catch BEFORE calling originalFetch
      // Headers may contain non-ASCII and throw when accessed
      let debugInfo = '[no debug - error accessing init]';
      try {
        const url: string = typeof input === 'string' ? input : (input instanceof URL ? input.href : (input as Request).url ?? '');
        if (url && convexUrl && url.startsWith(convexUrl)) {
          debugInfo = `url: ${url}`;
          // Try to access headers - this may throw if headers contain non-ASCII
          try {
            const hdrs = init?.headers;
            debugInfo += `, headers typeof: ${typeof hdrs}`;
            if (typeof hdrs === 'string') {
              debugInfo += `, string length: ${String(hdrs).length}`;
              console.log('[convex fetch]', debugInfo);
            } else if (hdrs instanceof Headers) {
              const entries = Array.from(hdrs.entries()).map(([k, v]) => [k, v ? `${String(v).slice(0, 10)}…(${String(v).length})` : v]);
              console.log('[convex fetch]', debugInfo, 'entries:', entries);
            } else if (hdrs && typeof hdrs === 'object') {
              const keys = Object.keys(hdrs);
              const authVal = ((hdrs as Record<string, unknown>)['Authorization'] ?? (hdrs as Record<string, unknown>)['authorization']) as string | undefined;
              console.log('[convex fetch]', debugInfo, 'keys:', keys, authVal ? `auth len: ${String(authVal).length}` : '');
            } else {
              console.log('[convex fetch]', debugInfo);
            }
          } catch (hdrErr) {
            console.error('[convex fetch] ❌ HEADERS ACCESS ERROR:', hdrErr, debugInfo);
            // Don't call originalFetch if headers are corrupt - will fail anyway
            throw hdrErr;
          }
        }
      } catch (e) {
        console.warn('[convex fetch] wrapper error:', e, debugInfo);
        // Still try to call originalFetch unless it's a headers error
        if (e && (e as Error).message?.includes('ISO-8859-1')) {
          throw e; // Re-throw headers error to see full stack
        }
      }
      return await originalFetch(input, init);
    };
  }
} catch {}
